import { getDefaultTranslationExperience, toggleDefaultTranslationExperience } from '../defaultTranslationExperience';

export const getTranslateOnLoad = (cookies) => getDefaultTranslationExperience(cookies);

export const setTranslateOnLoad = (value) => toggleDefaultTranslationExperience(value);
